import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

import useCellCopyAction from "../useCellCopyAction";
import { TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID } from "../constants";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsValueCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<OutputWithStack>) => {
  const displayValue = output.sensitive ? "••••••••" : output.value || "-";

  const copyAction = useCellCopyAction({
    column: TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.VALUE,
    text: displayValue,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={!output.sensitive ? actions : undefined}>
      <TableCellText>{displayValue}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentOutputsValueCell;
